import CardListMap from '../../Company/Payroll/Subcomponents/CardListMap';
import { IconClockTable, PersonChip } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomChip from '../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { status } from '../../../../enums/statusEnum';
import EmployeeSectionApp from '../Functionality/EmployeeSectionApp';
import DocumentationModal from '../modal/DocumentationModal';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat} from '../../../../Apis/functions';
import NotInformation from '../../../../components/NotInformation';
import AccessLogModal from '../modal/AccessLogModal';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EmployeeSection = ({ userTypeId, contractorId, profile, model, supplierId, historyModel, noInformationTitle }) => {
    const {
        t,
        selected,
        setSelected,
        searchId,
        results,
        searchElement,
        setSearchElement,
        setSearch,
        page,
        rowsPerPage,
        simpleSearch,
        setSimpleSearch,
        showDocumentationModal,
        setShowDocumentationModal,
        showAccessLogModal,
        setShowAccessLogModal,
        setData,
        getActionsButtons,
        pagination
    } = EmployeeSectionApp({
        contractorId,
        supplierId,
        model
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setSearchResults={setData}
                searchResults={results}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={model}
                page={page}
                rowsPerPage={rowsPerPage}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                label='search_by_name'
                contractorId={contractorId}
                supplierId={supplierId}
                setSearch={setSearch}
            />
            {results?.content?.length > 0 ? (
                <>
                    { results.content.map((item, index) => (
                        <CardListMap
                            key={item.userId}
                            icon={<PersonChip className='w-32px h-30px pt-8px' />}
                            backgroundColor='background-shades-100'
                            classContainerIcon='h-56px w-56px mt-10px background-primary-100'
                            colIcon='col-auto col-md-1 p-3 p-md-0'
                            colBody='col col-md-11'
                            body={
                                <>
                                    <div className='row align-items-center ml-2'>
                                        <div className='col-6 d-flex align-items-center'>
                                            <div className='flex-grow-1 minw-0'>
                                                <CustomTooltip
                                                    text={item.name}
                                                    classes='font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-2-rows ml-2 text-capitalize'
                                                    showIfTruncated
                                                    placement='top'
                                                />
                                            </div>
                                        </div>

                                        <div className='col-6 d-flex justify-content-end'>
                                            {getActionsButtons(item, index)}
                                        </div>
                                    </div>
                                    <div className='row align-items-center justify-content-start ml-3'>
                                        <div className='col-6 col-md-8 d-flex align-items-center gap-2 mb-2 mb-md-0'>
                                            <div>
                                                <IconClockTable className='icon-color-shades-500' />
                                            </div>
                                            <p className='fs-14px font-color-shades-500 ibl-font-w-400 mb-0 text-break'>
                                                {t('last_activity')}:{' '}
                                                { item?.updatedAt ?
                                                    getDateFormat(item?.updatedAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                                                    :
                                                    EMPTY_VALUES.DEFAULT
                                                }
                                            </p>
                                        </div>
                                        <div className='col-6 col-md-4 d-flex justify-content-end justify-content-md-end'>
                                            <CustomChip
                                                background={statusColor[item?.statusId]}
                                                fontColor={statusFontColor[item?.statusId]}
                                                borderColor={statusBorderColor[item?.statusId]}
                                                legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                                                variant={'large'}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        />
                    ))}
                    {pagination()}
                </>
            ) : (
                <NotInformation
                    text={t('no_employee_documentation')}
                    card={true}
                />
            )}
            {showDocumentationModal && (
                <DocumentationModal
                    show={showDocumentationModal}
                    onHide={() => setShowDocumentationModal(false)}
                    item={selected}
                    setItem={setSelected}
                    icon={<PersonChip className='mr-8px mb-1' />}
                    userTypeId={userTypeId}
                    profile={profile}
                    historyModel={historyModel}
                    noInformationTitle={noInformationTitle}
                />
            )}
            {showAccessLogModal && selected &&
                <AccessLogModal
                    show={showAccessLogModal}
                    item={selected}
                    onHide={() => setShowAccessLogModal(false)}
                />
            }
        </>
    );
};

export default EmployeeSection;
